module.exports = __webpack_public_path__ + "img/img_index_scene_jiaoyan@2x.17e32784.png";